// extracted by mini-css-extract-plugin
export var resizer = "_gw-0";